var map = {
	"./admin-page/admin-page.module": [
		"./src/app/admin-page/admin-page.module.ts",
		"default~admin-page-admin-page-module~admin-pages-admin-pages-module~auth-pages-auth-pages-module",
		"admin-page-admin-page-module"
	],
	"./admin-pages/admin-pages.module": [
		"./src/app/admin-pages/admin-pages.module.ts",
		"default~admin-page-admin-page-module~admin-pages-admin-pages-module~auth-pages-auth-pages-module",
		"default~admin-pages-admin-pages-module~auth-pages-auth-pages-module",
		"admin-pages-admin-pages-module"
	],
	"./auth-pages/auth-pages.module": [
		"./src/app/auth-pages/auth-pages.module.ts",
		"default~admin-page-admin-page-module~admin-pages-admin-pages-module~auth-pages-auth-pages-module",
		"default~admin-pages-admin-pages-module~auth-pages-auth-pages-module",
		"auth-pages-auth-pages-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;